import { __decorate } from "tslib";
import { consumeContext, watchContext } from '../../base/context';
import { mediaContext, MediaRemoteControl } from '../../media';
import { setAttribute } from '../../utils/dom';
import { ToggleButtonElement } from '../toggle-button';
export const MUTE_BUTTON_ELEMENT_TAG_NAME = 'vds-mute-button';
/**
 * A button for toggling the muted state of the player.
 *
 * 💡 The following attributes are updated for your styling needs:
 *
 * - `media-can-play`: Applied when media can begin playback.
 * - `media-muted`: Applied when media audio has been muted.
 *
 * @tagname vds-mute-button
 * @slot - Used to pass content into the mute toggle for showing mute/unmute states.
 * @csspart button - The button element (`<button>`).
 * @example
 * ```html
 * <vds-mute-button>
 *   <div class="mute">Mute</div>
 *   <div class="unmute">Unmute</div>
 * </vds-mute-button>
 * ```
 * @example
 * ```css
 * vds-mute-button[media-muted] .mute {
 *   display: none;
 * }
 *
 * vds-mute-button:not([media-muted]) .unmute {
 *   display: none;
 * }
 * ```
 */
export class MuteButtonElement extends ToggleButtonElement {
    constructor() {
        super(...arguments);
        this._mediaRemote = new MediaRemoteControl(this);
        this.label = 'Mute';
        this.pressed = mediaContext.muted.initialValue;
    }
    _handleButtonClick(event) {
        if (this.pressed) {
            this._mediaRemote.unmute(event);
        }
        else {
            this._mediaRemote.mute(event);
        }
    }
    _handleCanPlayContextUpdate(canPlay) {
        setAttribute(this, 'media-can-play', canPlay);
    }
    _handleMutedContextUpdate(muted) {
        setAttribute(this, 'media-muted', muted);
    }
}
__decorate([
    consumeContext(mediaContext.muted)
], MuteButtonElement.prototype, "pressed", void 0);
__decorate([
    watchContext(mediaContext.canPlay)
], MuteButtonElement.prototype, "_handleCanPlayContextUpdate", null);
__decorate([
    watchContext(mediaContext.muted)
], MuteButtonElement.prototype, "_handleMutedContextUpdate", null);
